import { useTranslation } from "react-i18next";
import { CheckCircle2 } from "lucide-react";

export function VenueQueueEmpty() {
  const { t } = useTranslation();

  return (
    <div
      data-testid="venue-queue-empty"
      className="flex flex-col items-center justify-center gap-4 rounded-lg border border-dashed border-border/60 py-16"
    >
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-emerald-50 text-emerald-600">
        <CheckCircle2 className="h-8 w-8" />
      </div>
      <div className="text-center">
        <p className="font-sans text-lg font-semibold text-foreground">
          {t("venues.queue.emptyTitle")}
        </p>
        <p className="mt-1 font-sans text-sm font-normal text-muted-foreground">
          {t("venues.queue.emptyBody")}
        </p>
      </div>
    </div>
  );
}
